import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";

import { ActionButton } from "../../../../components/Shared/Buttons";
import { translationKeys } from "../../../../models/app-translation-keys";
import { useStore } from "../../../../stores/StoreContext";

const chatbotFeatureTooltipTranslationKeys = translationKeys.feature.chatbot.tooltip;

export const NewThreadButton: FunctionComponent = observer(() => {
  const { t } = useTranslation();
  const { threadStore, sidebarStore } = useStore();
  const [tooltipTranslationKey, setTooltipTranslationKey] = useState<string>(
    chatbotFeatureTooltipTranslationKeys.startNewThread,
  );

  // NOTE #63781 if the user is anonymous and the active thread has a pending prompt, disable the ability to select another thread because the current thread does not exist on BE yet and switching threads will cause the pending prompt to be lost
  const anonymousPendingPrompt = sidebarStore.isAnonymous && !!threadStore.activeThread?.pendingPrompt;

  useEffect(() => {
    // if there are no exchanges in the active thread (the current thread does not exist on BE), disable the button and show a tooltip indicating that a new thread cannot be started because the user is already in a new thread/chat
    const disabled = !threadStore.activeThread?.exchanges?.length;
    setTooltipTranslationKey(
      disabled
        ? chatbotFeatureTooltipTranslationKeys.noActiveThreads
        : chatbotFeatureTooltipTranslationKeys.startNewThread,
    );
  }, [threadStore.activeThread?.exchanges?.length]);

  const handleNewThreadClick = () => {
    threadStore.resetActiveThread();
  };

  const showLabel = !sidebarStore.isCollapsed || sidebarStore.isOverlaySidebarVisible;

  return (
    <ActionButton
      id="new-thread-button"
      icon={faPlus}
      label={showLabel ? t(chatbotFeatureTooltipTranslationKeys.startNewThread) : undefined}
      onClick={handleNewThreadClick}
      tooltip={t(tooltipTranslationKey)}
      tooltipPosition="right"
      tooltipDisabled={showLabel}
      buttonDisabled={!threadStore.activeThread?.exchanges?.length || anonymousPendingPrompt}
      centeredHorizontally={showLabel}
      fullWidth={true}
    />
  );
});
